<template>
  <app-header></app-header>
  <div class="wrapper section member registerMemberInfo">
    <member-info :registerEdit="true"></member-info>
  </div>
  <app-footer></app-footer>
</template>

<script>
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import MemberInformation from '@/pages/memberCenter/MemberInfo.vue';

export default {
  name: 'MemberPage',
  components: {
    'member-info': MemberInformation,
    'app-header': AppHeader,
    'app-footer': AppFooter,
  },
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss">
.member section {
  width: 100% !important;
}
</style>
